import { render, staticRenderFns } from "./point_prompt.vue?vue&type=template&id=f9bd2f38&scoped=true&"
import script from "./point_prompt.vue?vue&type=script&lang=js&"
export * from "./point_prompt.vue?vue&type=script&lang=js&"
import style0 from "./point_prompt.vue?vue&type=style&index=0&id=f9bd2f38&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9bd2f38",
  null
  
)

export default component.exports